import { createContext } from "react";

export const GetHtmlCodeContext = createContext({
    registerGetHtmlCode: () => {},
});